import { useSearchParams } from "react-router-dom";
import { ALL, NONE } from "@miplatform/constants";
import { FilterSidebarInput } from "./FilterSidebar.types";

export function useFilterSearchParams<
  FilterValuesType extends FilterSidebarInput
>(initialFilters?: Partial<FilterValuesType>) {
  const [searchParams, setSearchParams] = useSearchParams();

  const setFiltersInSearchParams = (filters: FilterValuesType) => {
    Object.entries(filters as Record<string, string>).forEach(
      ([key, value]) => {
        if (value && value !== ALL && value !== NONE) {
          searchParams.set(key, value as string);
        } else {
          searchParams.delete(key);
        }
      }
    );
    setSearchParams(searchParams);
  };

  const getFiltersFromSearchParams = (): FilterValuesType | null => {
    if (searchParams.size === 0) {
      return null;
    }

    const filters = {
      ...initialFilters,
    } as FilterValuesType;

    searchParams.forEach((value, key: keyof FilterValuesType) => {
      if (value) {
        if (key === "groupBy") {
          filters.groupBy = value;
          return;
        }

        if (key === "sortBy") {
          filters.sortBy = value;
          return;
        }

        // @ts-expect-error - Not sure how to fix this type for now
        filters[key] = value;
      }
    });

    return filters;
  };

  const buildListUrlWithSearchParams = (
    baseUrl: string,
    filters: FilterValuesType
  ): string => {
    const params = new URLSearchParams();
    Object.entries(filters as Record<string, string>).forEach(
      ([key, value]) => {
        if (key === "groupBy") {
          if (value === initialFilters?.groupBy) return;

          params.set("groupBy", value as string);
        }

        if (key === "sortBy") {
          if (value === initialFilters?.sortBy) return;

          params.set("sortBy", value as string);
        }

        if (value && value !== ALL) {
          params.set(key, value as string);
        }
      }
    );
    const encodedParams = params.toString();

    return encodedParams ? `${baseUrl}?${encodedParams}` : baseUrl;
  };

  const clearSearchParams = () => {
    setSearchParams(new URLSearchParams());
  };

  return {
    searchParams,
    setSearchParams,
    setFiltersInSearchParams,
    getFiltersFromSearchParams,
    buildListUrlWithSearchParams,
    clearSearchParams,
  };
}
